<script setup lang="ts">
import ContactForm from '@@/vuecomponents/ContactForm.vue'
import LandsideFooterOld from '@@/vuecomponents/LandsideFooterOld.vue'
import ContactHeader from '@@/vuecomponents/contact_header.vue'
import ContactNav from '@@/vuecomponents/contact_nav.vue'
</script>

<template>
  <div>
    <header>
      <contact-nav />
    </header>
    <main id="main-content">
      <contact-header />
      <ContactForm />
    </main>
    <LandsideFooterOld />
  </div>
</template>

<style lang="scss">
@import '@@/styles/global';
@import '../library/v4/stylesheets/colors';
@import '@@/styles/4/dot_grid';

:root {
  --base-font-size: 16px;
  --body-text-color: black;
  --link-color: #{$pink-color};

  // For navigation bar
  --nav-background-color: #{$white};

  // For contact form
  --input-field-background-color: #{$white};
  --input-field-border-color: #{$light-grey-3};
  --input-field-text-color: #808080;
  --input-field-focused-border-color: #d0cece;
  --input-field-focused-box-shadow: #eeeeee;

  // For contact form options
  --radio-background-color: #{$muted-white};
  --radio-hover-color: rgba(220, 220, 220, 0.8);
  --radio-input-background-color: #ebe9e9;
  --radio-input-border-color: #{$white};
  --radio-checked-background-color: #dcdcdc;
  --radio-checked-input-background: #{$white};
}

html {
  font-family: Inter, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Ubuntu, 'Helvetica Neue', sans-serif;
  font-size: var(--base-font-size);
  color: var(--body-text-color);
  font-weight: 400;
  margin: 0;
  padding: 0;
}

body {
  @extend .dot-grid;

  margin: 0;
  padding: 0;
}

main {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (prefers-color-scheme: dark) {
  :root {
    --body-text-color: #{$inverse-body-text-color};

    // For navigation bar
    --nav-background-color: #1e1e1e;

    // For header
    --left-banner-color: rgb(9, 19, 40);
    --mid-banner-color: rgb(19, 36, 70);
    --right-banner-color: rgb(78, 93, 97);

    // For contact form
    --input-field-background-color: #{$dark-grey-6};
    --input-field-border-color: rgb(19, 36, 70);
    --input-field-text-color: #{$light-grey-text-3};
    --input-field-focused-border-color: #2e2e2e;
    --input-field-focused-box-shadow: #2e2e2e;

    // For contact form options
    --radio-background-color: #0d0d0d;
    --radio-hover-color: #2e2e2e;
    --radio-input-background-color: #141414;
    --radio-input-border-color: rgb(88, 86, 86);
    --radio-checked-background-color: rgb(99, 98, 98);
    --radio-checked-input-background: #b5afaf;
  }
}
</style>
